import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
const classNames = require('classnames');

import * as navigationHelper from 'app-lib/helpers/navigation-helper';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

import config from 'config';

export class MenuOverlay extends React.Component {
    navigateToLearnMore() {
        this.props.hideMenuOverlay();
        navigationHelper.navigateToLearnMore();
    }

    navigateToChannel() {
        this.props.hideMenuOverlay();
        navigationHelper.navigateToChannel(this.props.myChannelKey);
    }

    signOut() {
        this.props.hideMenuOverlay();
        navigationHelper.signOut();
    }

    analyticsClicked() {
        this.props.hideMenuOverlay();
        mixpanelTracker.track(`${mixpanelTracker.analyticsClicked}`);
    }

    renderMyChannelListItem() {
        if (!this.props.myChannelKey) {
            return null;
        }
        return (<li>
            <span className="menu-list-icon togo-icon togo-icon-play togo-icon-2x"></span>
            <span><a className="menu-list-item" onClick={this.navigateToChannel.bind(this)}>{i18n.t('SharedComponents.header-nav.myChannel')}</a></span>
        </li>);
    }

    renderAnalyticsListItem() {
        if (!this.props.myChannelKey) {
            return null;
        }
        return (<li>
            <span className="menu-list-icon togo-icon togo-icon-linechart togo-icon-2x"></span>
            <span><a
              className="menu-list-item"
              href={`${config.analytics.baseUrl}`}
              target="_blank" rel="noopener" onClick={this.analyticsClicked.bind(this)}
            >{i18n.t('SharedComponents.header-nav.analytics')}</a></span>
        </li>);
    }

    render() {
        const {displayMenuOverlay} = this.props;
        const menuOverlayClasses = classNames('menu-overlay', {
            'menu-overlay-slide-in animated slideInRight': displayMenuOverlay
        });
        return (
            <div className={menuOverlayClasses}>
                <div className="menu-list">
                    <div className="menu-close" onClick={this.props.hideMenuOverlay}><span className="togo-icon togo-icon-closes togo-icon-2x"></span></div>
                    <ul>
                        {this.renderMyChannelListItem()}
                        <li>
                            <span className="menu-list-icon togo-icon togo-icon-bulb togo-icon-2x"></span>
                            <span>
                                <a className="menu-list-item" onClick={this.navigateToLearnMore.bind(this)}>
                                      {i18n.t('learnMore.learn-more')}
                                </a>
                            </span>
                        </li>
                        {this.renderAnalyticsListItem()}
                        <li>
                            <span className="menu-list-icon togo-icon togo-icon-leave-meeting togo-icon-2x"></span>
                            <span>
                                <a className="menu-list-item" onClick={this.signOut.bind(this)}>
                                       {i18n.t('navbar.signOut')}
                                </a>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

MenuOverlay.propTypes = {
    displayMenuOverlay: PropTypes.bool.isRequired,
    hideMenuOverlay: PropTypes.func.isRequired,
    myChannelKey: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/overlays/menu-overlay.js